export default __webpack_public_path__ + "media/img/primary-c7e334e7f245350fc2fa5dd5fe7ce6a3.svg";